import React from "react";
import { Tooltip, Text } from "@chakra-ui/react";

import { useConfigurationThemeConsumer } from "ChakraTheme";

import { IconButton } from "components/IconButton";

const BigLettersButton = () => {
  const { dispatch } = useConfigurationThemeConsumer();
  const bigLetterSizeMessage = "Bardzo duża wielkość liter";
  return (
    <Tooltip label={bigLetterSizeMessage} aria-label={bigLetterSizeMessage}>
      <IconButton
        id="big-letters-btn"
        aria-label={bigLetterSizeMessage}
        background="transparent"
        size="lg"
        icon={<Text fontSize="lg">A++</Text>}
        onClick={() => dispatch({ type: "FONT_SIZE_LARGE" })}
      />
    </Tooltip>
  );
};

export { BigLettersButton };
